import { formatIDR } from "@kanata/shared";
import type { PublicPromo } from "@/lib/api";

/**
 * The last day a promotion applies, as a customer reads it: "31 Des 2026".
 *
 * A promotion's window is half-open — it ends *at* endsAt — so a promo that
 * runs "until 31 December" is stored ending at 1 January 00:00 WIB. Showing
 * that instant would tell the customer it lasts a day longer than it does,
 * so the label is the moment just before it, in Jakarta time.
 */
export function promoEndsLabel(endsAt?: string): string | null {
  if (!endsAt) return null;
  const end = new Date(endsAt);
  if (Number.isNaN(end.getTime())) return null;
  return new Intl.DateTimeFormat("id-ID", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Jakarta",
  })
    .format(new Date(end.getTime() - 1))
    .replace(/\./g, "");
}

/**
 * What a promotion gives, as a phrase: "Putar Table Wheels gratis, packing
 * kayu gratis, dan subsidi ongkir s/d Rp 100.000".
 */
export function promoBenefits(promo: PublicPromo): string {
  const parts: string[] = [];
  if (promo.gift) parts.push(`${promo.gift.productName} gratis`);
  if (promo.packingKayuPriceIdr) parts.push("packing kayu gratis");
  if (promo.shippingSubsidyMaxIdr > 0) parts.push(`subsidi ongkir s/d ${formatIDR(promo.shippingSubsidyMaxIdr)}`);
  if (parts.length <= 1) return parts.join("");
  return `${parts.slice(0, -1).join(", ")}, dan ${parts[parts.length - 1]}`;
}
